import {useContext} from 'react';
import {storeContext} from "../storage";

export const useStorageTranslateContext = () => useContext(storeContext);
